import { Injectable } from '@angular/core';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import { Vehicle } from '../model/vehicle.model';
import 'parse';
const parse: typeof Parse = require('parse');

@Injectable()
export class VehicleService implements ParseAPIService<Vehicle> {
  store: DbObjectsStore<Vehicle>;

  constructor() {
    this.store = {};
  }


  public async getAll(limit?: number): Promise<Vehicle[]> {
    const query = this.baseQuery();
    if (typeof limit === 'number')
      query.limit(limit);
    try {
      const foundObjects = await query.find();
      foundObjects.forEach(o => this.store[o.id] = new Vehicle(o));
      return Object.values(this.store);
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  public async get(id: string): Promise<Vehicle> {
    const query = this.baseQuery();
    try {
      this.store[id] = new Vehicle(await query.get(id));
      return this.store[id];
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }

  public async getByTchek(id: string): Promise<Vehicle[]> {
    const query = this.baseQuery();
    const tchek = new parse.Object('Tchek');
    tchek.id = id;
    try {
      await tchek.fetch();
      const vehiclesFound = [];
      (await query.equalTo('tchekPtr', tchek).find())
        .forEach(d => {
          this.store[d.id] = new Vehicle(d);
          vehiclesFound.push(this.store[d.id]);
        });
      return vehiclesFound;
    } catch (e) {
      console.error(e);
      return undefined;
    }
  }
  public async saveVehicle(
    vehicleId: string,
    immat: string,
    brand: string,
    model: string,
    or: string,
    vin: string,
    className: string,
    tchekId: string
  ): Promise<Vehicle | Vehicle[]> {
    try {
      const vehiclesFound = [];
      const savedObjects = await parse.Cloud.run('updateVehicle', {
        vehicleId: vehicleId,
        immat: immat,
        class: className,
        brand: brand,
        model: model,
        vin: vin,
        or: or,
        tchekId: tchekId
      })
      console.log("savedObjects", savedObjects.id)
      // make sure the set the email sent flag on the object
      this.store[savedObjects.id] = new Vehicle(savedObjects);
      vehiclesFound.push(this.store[savedObjects.id]);
      return vehiclesFound;

    } catch (e) {
      console.error(e);
      return [];
    }
  }

  public async save(vehicle: Vehicle | Vehicle[]): Promise<Vehicle | Vehicle[]> {
    if (Array.isArray(vehicle)) {
      const array = vehicle.map<Parse.Object>(r => r.getParseInstance());
      try {
        const savedObjects = await parse.Object.saveAll(array);
        const vehiclesFound = [];
        savedObjects.forEach(d => {
          this.store[d.id] = new Vehicle(d);
          vehiclesFound.push(this.store[d.id]);
        });
        return vehiclesFound;
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const savedObject = await vehicle.getParseInstance().save();
        this.store[savedObject.id] = new Vehicle(savedObject);
        return this.store[savedObject.id];
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async delete(vehicle: Vehicle | Vehicle[]): Promise<Vehicle | Vehicle[]> {
    if (Array.isArray(vehicle)) {
      const array = vehicle.map<Parse.Object>(r => {
        r.isDeleted = true;
        return r.getParseInstance();
      });
      try {
        const deletedObjects = await parse.Object.saveAll(array);
        return deletedObjects.map<Vehicle>(o => new Vehicle(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        vehicle.isDeleted = true;
        const deletedObject = await vehicle.getParseInstance().save();
        return new Vehicle(deletedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  public async destroy(vehicle: Vehicle | Vehicle[]): Promise<Vehicle | Vehicle[]> {
    if (Array.isArray(vehicle)) {
      const array = vehicle.map<Parse.Object>(r => r.getParseInstance());
      try {
        const destroyedObjects = await parse.Object.destroyAll(array);
        return destroyedObjects.map<Vehicle>(o => new Vehicle(o));
      } catch (e) {
        console.error(e);
        return [];
      }
    } else {
      try {
        const destroyedObject = await vehicle.getParseInstance().destroy();
        return new Vehicle(destroyedObject);
      } catch (e) {
        console.error(e);
        return undefined;
      }
    }
  }

  private baseQuery(): Parse.Query {
    return new parse.Query('Vehicle')
      .notEqualTo('isDeleted', true)
      .include(['companyPtr']);
  }

}



// WEBPACK FOOTER //
// ./src/app/service/vehicle.service.ts